export default __webpack_public_path__ + "static/media/pictogramBeaconCards48.2bdc9c74.svg";